import { useQuery } from 'react-query';
import { ONE_HOUR } from 'shared/constants';
import { useService } from 'shared/providers';

export function useDropdownOptions(optionType: string) {
  const { customerCommodityService } = useService();

  return useQuery(
    ['dropdown-options', optionType],
    () => customerCommodityService.getCustomerCommodityOptions(optionType),
    {
      staleTime: ONE_HOUR,
      retry: false,
    }
  );
}
